import Paragraph from "atoms/typography/paragraph";
import React from "react";
import useBreakpointRanges from "utilities/hooks/use-breakpoint-ranges";
import { AriaRole } from "utilities/enumerations/aria-role";
import { NfpaWithHtml } from "constants/app-name-tm";
import { useLocalization } from "utilities/hooks/use-localization";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

export interface NewChatProps {
    isBookview: boolean;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const BASE_CLASS = "c-chat-modal-results";

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const NewChat: React.FC<NewChatProps> = React.memo(({ isBookview }) => {
    const { t } = useLocalization();
    const { inMobileView } = useBreakpointRanges();

    return (
        <div
            aria-label={t("chatModal-ChatResults")}
            className={`${BASE_CLASS}__new-chat ${isBookview ? "-bookview" : ""}`}
            role={AriaRole.List}>
            <div
                className={`${BASE_CLASS}__casi${isBookview ? "-bookview" : ""}`}
            />
            <div
                className={`${BASE_CLASS}__new-chat-header ${isBookview ? "-bookview" : ""}`}>
                {!isBookview
                    ? t("new-chat-prompt-header")
                    : t("bookview-casi-intro")}
            </div>
            <div className={`${BASE_CLASS}__new-chat-subheader`}>
                {!isBookview ? (
                    <>
                        <Paragraph
                            cssClassName={`${BASE_CLASS}__new-chat-subheader`}
                            dangerouslySetInnerHTML={{
                                __html: t("new-chat-subheader-one", {
                                    appName: NfpaWithHtml,
                                }),
                            }}
                        />
                        <Paragraph
                            cssClassName={`${BASE_CLASS}__new-chat-subheader`}>
                            {t("new-chat-subheader-two")}
                        </Paragraph>
                        {inMobileView && <br />}
                        <Paragraph
                            cssClassName={`${BASE_CLASS}__new-chat-subheader`}>
                            {t("new-chat-subheader-three")}
                        </Paragraph>
                    </>
                ) : (
                    <Paragraph>{t("new-chat-prompt-header")}</Paragraph>
                )}
            </div>
        </div>
    );
});
// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default NewChat;

// #endregion Exports
